import React, { useCallback } from "react";
import { Paths } from "../../../../Paths";
import { AdminOnlyComponents } from "../../admin/components/AdminOnlyComponents";
import { AddButton } from "../../common/button/AddButton";
import { useNavigate } from "react-router-dom";

export const AdminInformationAddButton = React.memo(function AdminInformationAddButton() {
    const navigate = useNavigate();

    // お知らせ追加ページへ遷移
    const handleInformationAddClicked = useCallback(() => navigate(`${Paths.admin}${Paths.information}${Paths.add}`), [navigate]);

    return (
        <AdminOnlyComponents>
            <div className={"add_button_area"} onClick={handleInformationAddClicked}>
                <AddButton label="お知らせを追加する" onClick={handleInformationAddClicked} />
            </div>
        </AdminOnlyComponents>
    );
});
